export const BeneficiaryServiceStatus = [
  'SIGNED',
  'CLOSED'
]
